import ResetPickTour from './ResetPickTour';

export default ResetPickTour;
